var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#F7F8FB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.052 29.3249C19.052 28.8267 18.7123 28.5295 18.1129 28.5295C17.8682 28.5295 17.7024 28.5541 17.6157 28.5776V30.1761C17.7184 30.1997 17.8446 30.2075 18.0185 30.2075C18.6574 30.2075 19.052 29.879 19.052 29.3249Z",
  fill: "#84B8E8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7605 28.5464C22.4921 28.5464 22.3187 28.57 22.2161 28.5944V32.1346C22.3187 32.1592 22.4845 32.1592 22.6343 32.1592C23.7232 32.167 24.4334 31.557 24.4334 30.2645C24.4411 29.1406 23.794 28.5464 22.7605 28.5464Z",
  fill: "#84B8E8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5482 10H17.7082C15.9785 10 14.5707 11.4337 14.5707 13.193V25H14.2643C13.5662 25 13 25.5756 13 26.2867V34.0897C13 34.8007 13.5661 35.3762 14.2643 35.3762H14.5707V36.807C14.5707 38.5683 15.9785 40 17.7082 40H33.8634C35.592 40 37 38.5682 37 36.807V17.5569L29.5482 10ZM16.3168 27.6948C16.6873 27.6311 17.2081 27.5831 17.9419 27.5831C18.6834 27.5831 19.2119 27.7271 19.567 28.0165C19.9062 28.2891 20.1352 28.7392 20.1352 29.2688C20.1352 29.7983 19.9617 30.2485 19.6461 30.5535C19.2356 30.9467 18.6285 31.1232 17.9183 31.1232C17.7603 31.1232 17.6186 31.1153 17.5078 31.0997V33.0345H16.3168V27.6948ZM33.8634 38.0446H17.7082C17.0385 38.0446 16.4931 37.4896 16.4931 36.807V35.3762H31.553C32.2513 35.3762 32.8174 34.8007 32.8174 34.0897V26.2867C32.8174 25.5756 32.2513 25 31.553 25H16.4931V13.193C16.4931 12.5124 17.0386 11.9573 17.7082 11.9573L28.8294 11.9455V16.1289C28.8294 17.3509 29.8036 18.3433 31.0053 18.3433L35.0322 18.3315L35.0775 36.807C35.0775 37.4896 34.5331 38.0446 33.8634 38.0446ZM20.9032 33.01V27.6948C21.3449 27.6233 21.9207 27.5831 22.5283 27.5831C23.5382 27.5831 24.193 27.7674 24.7061 28.1606C25.2583 28.5784 25.6051 29.2443 25.6051 30.2004C25.6051 31.2359 25.2346 31.9509 24.7214 32.3921C24.1616 32.8657 23.3093 33.0904 22.2681 33.0904C21.6446 33.0904 21.2028 33.0502 20.9032 33.01ZM29.5136 29.8631V30.8584H27.6042V33.0345H26.3972V27.6233H29.6475V28.6264H27.6042V29.8631H29.5136Z",
  fill: "#84B8E8"
});

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.9c08144f.svg";
export { ForwardRef as ReactComponent };